import { lazy } from 'react';

const PlatformDashboard = lazy(() => import('../../pages/PlatformAdmin/PlatformDashboard'));

// Platform super-admin routes (cross-org). Guarded to the 'Platform' role only.
const platformRoutesConfig = [
  { path: '/platform/dashboard', component: PlatformDashboard },
];

export default platformRoutesConfig;
